import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  data() {
    return {
      // 下拉采集模板列表
      collectionTemplateList: [],
      collectionTemplateTypeOptionsList: [],
      // 分页配置项
      setCollectionTemplatePage: {
        pageSize: 20, // 每页显示条数
        currentPage: 1, // 当前页
        total: 0, // 总条数
        totalPage: 1
      }
    }
  },
  created() {
  },
  methods: {
    initCollectionTemplateList() {
      const data = {
        pageNo: this.setCollectionTemplatePage.currentPage,
        pageSize: this.setCollectionTemplatePage.pageSize
      }
      SmartVehicleInspection.getCollectionTemplateList(data).then(res => {
        if (res.success) {
          const { records, total, size, pages } = res.result
          this.setCollectionTemplatePage.pageSize = size;
          this.setCollectionTemplatePage.total = total;
          this.setCollectionTemplatePage.totalPage = pages;
          let arr = [];
          records.map((value, index) => {
            let obj = {};
            obj.sort = index + 1;
            obj.id = value.id;
            obj.name = value.name;
            obj.status = value.status;
            obj.templateType = value.templateType;
            obj.versionNo = value.versionNo;
            obj.exportMode = value.exportMode;
            arr.push(obj);
          });
          this.collectionTemplateList = arr;
          this.collectionTemplateTypeOptionsList = this.collectionTemplateTypeOptionsList.concat(arr);
        }
      })
    },
    
    // 给自定义指令用的方法
    handleCollectionTemplateScrollDropdown() {
      this.setCollectionTemplatePage.currentPage++
      // 这一步是做了一个容错判断 currentPage>totalPage 时 return出去
      if (this.setCollectionTemplatePage.currentPage > this.setCollectionTemplatePage.totalPage) return
      // 获取列表接口
      this.initCollectionTemplateList()
    }
  }
}